import request from "../../utils/request";
const Authorization = localStorage.getItem("Authorization");
// 管理员视角--批量加好友
export function getFriendTask(params, authorization) {
  return request({
    url: "/api/qywechat/friendTask/admin",
    method: "get",
    params,
    headers: {
      authorization: authorization,
    },
  });
}

// 创建单条数据 /api/qywechat/friendTask/newTask

export function postNewTask(params, authorization) {
  return request({
    url: "/api/qywechat/friendTask/newTask",
    method: "post",
    data: params,
    headers: {
      authorization: authorization,
    },
  });
}

//  分配任务 /api/qywechat/friendTask/allocation

export function postAllocation(params, authorization) {
  return request({
    url: "/api/qywechat/friendTask/allocation",
    method: "post",
    data: params,
    headers: {
      authorization: authorization,
    },
  });
}

//   分配情况--get 127.0.0.1:8016/api/qywechat/friendTask/statistic
export function getStatisticList(params, authorization) {
  return request({
    url: "/api/qywechat/friendTask/statistic",
    method: "get",
    params,
    headers: {
      authorization: authorization,
    },
  });
}

// 编辑任务 post 127.0.0.1:8016 /api/qywechat/friendTask/updateTask
export function postUpdateTask(params, authorization) {
  return request({
    url: "/api/qywechat/friendTask/updateTask",
    method: "post",
    data: params,
    headers: {
      authorization: authorization,
    },
  });
}

// 员工视角---XXX
// 获取客户资源 /api/qywechat/friendTask/emp
export function getEmpList(params, authorization) {
  return request({
    url: "/api/qywechat/friendTask/emp",
    method: "get",
    params,
    headers: {
      authorization: authorization,
    },
  });
}
// 更改任务状态  /api/qywechat/friendTask/updateTask
// export function postUpdateTask(params, authorization) {
//   return request({
//     url: "/api/qywechat/friendTask/updateTask",
//     method: "post",
//     data:params,
//     headers: {
//       authorization: authorization,
//     },
//   });
// }

// 导入导出
export function importData(data, isLoading) {
  return request(
    {
      url: `/api/qywechat/friendTask/importData`,
      method: "post",
      data,
      headers: {
        authorization: Authorization,
        "Content-Type": "multipart/form-data",
      },
    },
    isLoading
  );
}

// 设置 resume
export function postResume(params, authorization) {
  return request({
    url: "/api/qywechat/friendTask/resume",
    method: "post",
    data: params,
    headers: {
      authorization: authorization,
    },
  });
}

// 获取设置的时间期限  /api/qywechat/friendTask/resumedata
export function postResumedata(authorization) {
  return request({
    url: "/api/qywechat/friendTask/resumedata",
    method: "post",
    headers: {
      authorization: authorization,
    },
  });
}

// 获取客户资源列表 /api/qywechat/friendTask/admin//admin/empData
export function getEmpData(authorization) {
  return request({
    url: "/api/qywechat/friendTask/admin/empData",
    method: "get",
    headers: {
      authorization: authorization,
    },
  });
}
